<template>
  <div id="kt_content" class="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
    <div class="kt-subheader   kt-grid__item">
      <div class="kt-container  kt-container--fluid ">
        <div class="kt-subheader__main">
          <h3 class="kt-subheader__title">
            Credential
          </h3>
          <span class="kt-subheader__separator kt-hidden" />
          <div class="kt-subheader__breadcrumbs">
            <router-link to="/" class="kt-subheader__breadcrumbs-home">
              <i
                class="flaticon2-shelter"
                @click="trackCustomEvent({ action: 'clicked', target: 'breadcrumbs_content', linkTo: 'overview' })"
              />
            </router-link>
            <span class="kt-subheader__breadcrumbs-separator" />
            <router-link :to="`/dashboard/${projectId}`" class="kt-subheader__breadcrumbs-link">
              <span @click="trackCustomEvent({ action: 'clicked', target: 'breadcrumbs_content', linkTo: 'dashboard' })">
                Project
              </span>
            </router-link>
            <span class="kt-subheader__breadcrumbs-separator" />
            <span class="kt-subheader__breadcrumbs-link kt-subheader__breadcrumbs-link--active">Credential</span>
          </div>
        </div>
      </div>
    </div>
    <div class="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
      <div class="kt-portlet">
        <div class="kt-portlet__body">
          <LoadingSpinner v-if="!isLoaded" />
          <Projectcomponent v-else :project-detail-state="projectDetailState" />
        </div>
      </div>

      <div class="kt-portlet">
        <div class="kt-portlet__head">
          <div class="kt-portlet__head-label">
            <h3
              class="kt-portlet__head-title"
            >
              {{ tokensDetail.length }} token{{ tokensDetail.length > 1 ? 's' : '' }}
            </h3>
          </div>
          <div class="kt-portlet__head-toolbar">
            <button
              v-b-modal.modal-create-token
              class="btn btn-brand btn-icon-sm"
              @click="trackCustomEvent({ action: 'clicked', target: 'create_token_content' })"
            >
              <i class="flaticon2-plus" />
              Create a token
            </button>
          </div>
        </div>

        <div class="kt-portlet__body">
          <div class="kt-section">
            <div class="kt-section__content">
              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>
                        Token
                        <i class="la la-info-circle kt-icon-lg" data-toggle="tooltip" data-placement="right" title="Copy token to send with a web service request." />
                      </th>
                      <th>Granted service</th>
                      <th>Last access</th>
                      <th width="90">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="isTokenDetailLoading">
                      <td colspan="10" style="text-align: center">
                        <LoadingSpinner />
                      </td>
                    </tr>
                    <tr v-else-if="tokensDetail.length === 0">
                      <td colspan="10" style="text-align: center">
                        <div class="d-flex flex-column justify-content-center align-items-center kt-label-font-color-1" style="height: 250px">
                          <ListIcon />
                          <h5><span>No Data Available</span></h5>
                          <p>Please create a new token</p>
                        </div>
                      </td>
                    </tr>
                    <tr v-for="(token, idx) in tokensDetail" v-else :key="idx">
                      <th scope="row">
                        {{ idx + 1 }}
                      </th>
                      <td>
                        {{ token.name }}<br>
                        <span class="kt-label-font-color-1">{{ token.token }}</span>
                        <span>
                          <button
                            v-clipboard:copy="token.token"
                            type="button"
                            class="btn btn-sm btn-clean btn-icon btn-icon-sm"
                            @click="trackCustomEvent({ action: 'clicked', target: 'copy_content' }); triggerCopiedTooltip(idx)"
                            @mouseover="disableTooltip(idx)"
                            @mouseleave="disableTooltip(idx)"
                          >
                            <i :id="`tooltip-copy-${idx}`" class="la la-copy" :data-toggle="`tooltip-copy-${idx}`" data-placement="right" title="Copied!" />
                          </button>
                        </span>
                      </td>
                      <td>
                        <ul v-if="token.associatedServices && token.associatedServices.length > 0" class="list-group list-group-flush" style="list-style: none;">
                          <li v-for="(service, serviceIdx) in token.associatedServices" :key="serviceIdx">
                            {{ service.name }}
                          </li>
                        </ul>
                        <div v-else>
                          None
                        </div>
                      </td>
                      <td>{{ token.lastAccess | date }}</td>
                      <td>
                        <a
                          class="btn btn-sm btn-clean btn-icon btn-icon-md"
                          @click="trackCustomEvent({ action: 'clicked', target: 'button_content' }); editToken(token.token)"
                        >
                          <i class="la la-edit" />
                        </a>

                        <a
                          class="btn btn-sm btn-clean btn-icon btn-icon-md"
                          @click="trackCustomEvent({ action: 'clicked', target: 'button_content' }); deleteToken(token.token, token.associatedServices)"
                        >
                          <i class="la la-trash" />
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <create-token-modal
            id="modal-create-token"
            :project-id="projectId"
            :user-id="getUserDetail.userId"
            @tokenCreated="updateNewToken"
          />
          <edit-token-modal
            id="modal-edit-token"
            ref="edit-token-modal"
            :project-id="projectId"
            :user-id="getUserDetail.userId"
            @tokenUpdated="updateEditedToken"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import Swal from 'sweetalert2'
import { VBModal } from 'bootstrap-vue'
import Projectcomponent from '../components/ProjectDetail'
import CreateNewTokenModal from '../components/CreateNewTokenModal'
import EditTokenModal from '../components/EditTokenModal'
import LoadingSpinner from '../components/LoadingSpinner'
import ListIcon from '../components/ListIcon'

export default {
  components: {
    ListIcon,
    Projectcomponent,
    LoadingSpinner,
    'create-token-modal': CreateNewTokenModal,
    'edit-token-modal': EditTokenModal
  },
  directives: {
    'b-modal': VBModal
  },
  filters: {
    date (value) {
      if (value) {
        return moment(value).format('DD/MM/YYYY HH:mm')
      } else {
        return 'Never'
      }
    }
  },
  data () {
    return {
      // projectDetail: {},
      project: {
        detail: {},
        errorCount: 0
      },
      tokensDetail: [],
      selectedToken: false,
      date: false,
      isTokenDetailLoading: true,
      isLoaded: false
    }
  },
  computed: {
    ...mapGetters({
      getUserDetail: 'user/getUserDetail',
      getProjectDetailState: 'project/getProjectDetailState'
    }),
    projectId () {
      return this.$route.params.projectId
    },
    projectDetailState () {
      return this.getProjectDetailState[this.projectId]
    }
  },
  async mounted () {
    // await this.projectDetailRequest
    this.getTokensDetail()
    this.isLoaded = true
    $('[data-toggle="tooltip"]').tooltip()
    // $('[data-toggle="tooltip-copy"]').trigger('manual')
  },
  methods: {
    ...mapActions({
      getProjectDetailRequest: 'project/getProjectDetail',
      getProjectErrorCount: 'project/getProjectErrorCount',
      getTokensDetailRequest: 'project/getTokensDetail',
      deleteTokenRequest: 'project/deleteToken',
      trackCustomEvent: 'user/trackCustomEvent'
    }),
    disableTooltip (idx) {
      $('[data-toggle=' + `tooltip-copy-${idx}` + ']').tooltip('hide')
    },
    triggerCopiedTooltip (idx) {
      $('[data-toggle=' + `tooltip-copy-${idx}` + ']').tooltip('show')
    },
    async updateNewToken (newToken) {
      this.tokensDetail.push(newToken)
    },
    updateEditedToken (updatedToken) {
      const tokenIndex = this.tokensDetail.findIndex(
        token => token.token.toString() === updatedToken.token.toString()
      )
      this.$set(this.tokensDetail, tokenIndex, updatedToken)
    },
    async getTokensDetail () {
      const response = await this.getTokensDetailRequest(this.projectId)
      this.tokensDetail = response.data || []
      this.tokensDetail.forEach(token => {
        if (token.associatedServices) {
          token.associatedServices = token.associatedServices.sort((a, b) => a.name.localeCompare(b.name))
        }
      })
      this.isTokenDetailLoading = false
    },
    editToken (token) {
      this.$refs['edit-token-modal'].show(token)
    },
    deleteToken (token, services) {
      Swal.fire({
        title: 'Delete token?',
        text: 'This operation cannot be undone.',
        type: 'warning',
        heightAuto: false,
        showCancelButton: true,
        cancelButtonText: 'Cancel',
        confirmButtonText: 'Delete',
        confirmButtonColor: 'red',
        showCloseButton: true,
        reverseButtons: true,
        showLoaderOnConfirm: true,
        preConfirm: async e => {
          this.trackCustomEvent({ action: 'clicked', target: 'swal_delete_content' })
          const response = await this.deleteTokenRequest({
            projectId: this.projectId,
            userId: this.getUserDetail.userId,
            token: token
          })
          if (response) {
            await this.getProjectDetailRequest(this.projectId)
            await this.getTokensDetail()
          } else {
            Swal.showValidationMessage('Cannot delete token.')
          }
        }
      }).then(res => {
        if (res.dismiss === Swal.DismissReason.cancel) {
          this.trackCustomEvent({ action: 'clicked', target: 'swal_cancel_content' })
        }
      })
    }
  }
}
</script>

<style scoped>
/* .kt-subheader--enabled.kt-subheader--transparent:not(.kt-subheader--fixed)
  .kt-content {
  padding-top: 0;
} */
.kt-subheader {
  margin-top: 0px;
}
table button {
  margin: 0 0.3em;
}
.badge {
  margin: 0 0.2em;
  cursor: pointer;
}
.service {
  margin: 0.12em 0; /* FIXME: How to make two lists in <td> align */
}
</style>
